module.exports = __webpack_public_path__ + "img/4@2x.a6987f99.png";